import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { DropdownWithDisplay } from 'reusableComponents/DropdownWithDisplay'
import {
  selectSortPackagePinsByStatus,
  selectVendor,
  selectActivePinDetails,
  selectSelectedPin,
} from 'store/shipping/shippingSelectors'
import { colors } from 'globalStyles'
import { VendorStyle, LogoStyle, StyledTrackingCard } from './Tracking.style'

const getImagePath = (vendorName) => {
  const imageName = vendorName.replaceAll(' ', '-')
  const imagePath = `${process.env.PUBLIC_URL}/assets/logo/${imageName}.svg`

  return (
    <LogoStyle>
      <img className="imageRight" alt="vendor" src={imagePath} />
    </LogoStyle>
  )
}
const getVendor = (vendorName) => {
  if (vendorName === 'Dell' || vendorName === 'Canadian Tire') {
    return getImagePath(vendorName)
  }
  return <VendorStyle> {vendorName} </VendorStyle>
}

const getStatus = (shipmentStatusCode, t) => {
  if (shipmentStatusCode === 1 || shipmentStatusCode === 2) {
    return t('status_message.on_the_way')
  }
  if (shipmentStatusCode === 3) {
    return t('status_message.delivered')
  }
  return t('status_message.attention')
}

const TrackingNumber = ({ onSelectPinHandler }) => {
  const { t } = useTranslation()
  const shipmentPins = useSelector(selectSortPackagePinsByStatus)
  const vendorName = useSelector(selectVendor)
  const vendor = getVendor(vendorName)
  const activePin = useSelector(selectSelectedPin)
  const numOfPackage = shipmentPins.length
  const trackingDetails = useSelector(selectActivePinDetails)
  const { statuscode: shipmentStatusCode } = trackingDetails
  const statusMessage = getStatus(shipmentStatusCode, t)
  const statusStyle = {
    color: [1, 2, 3].includes(shipmentStatusCode) ? colors.primary_blue : colors.primary_red,
    fontWeight: 600,
    padding: '0',
    display: 'flex',
    alignItems: 'center',
  }

  const styledSpan = {
    padding: '0',
    display: 'block',
    alignItems: 'center',
  }

  const styledTrackingPin = {
    fontWeight: 600,
  }

  return (
    <StyledTrackingCard
      title={
        numOfPackage > 1 ? (
          <DropdownWithDisplay
            items={shipmentPins}
            selectedValueHandler={onSelectPinHandler}
            activePin={activePin}
          />
        ) : (
          <span style={statusStyle}>{statusMessage}</span>
        )
      }
      companyLogo={vendor}
    >
      <span style={styledSpan} id="tracking-number-span">
        <span style={styledTrackingPin}>{t('tracking_pin')}</span>
        {numOfPackage > 1 ? activePin : shipmentPins}
      </span>
    </StyledTrackingCard>
  )
}

TrackingNumber.propTypes = {
  onSelectPinHandler: PropTypes.func.isRequired,
}

export default TrackingNumber
